/**
 * Gallery mouse tracking functionality
 * Creates a glass-like hover effect that follows the mouse cursor
 *
 * @package Lastag
 * @version 1.0.0
 */

export function initializeGallery() {
    const galleryItems = document.querySelectorAll('.gallery-item');
    const galleryTextSection = document.querySelector('.gallery-text-section');
    
    if (!galleryItems.length) {
        return;
    }

    galleryItems.forEach(item => {
        item.addEventListener('mousemove', handleMouseMove);
        item.addEventListener('mouseleave', handleMouseLeave);
    });

    if (galleryTextSection) {
        galleryTextSection.addEventListener('animationend', function(e) {
            if (e.animationName === 'fadeInUp') {
                this.classList.add('animated');
            }
        });
    }

    function handleMouseMove(e) {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        e.currentTarget.style.setProperty('--mouse-x', `${x}%`);
        e.currentTarget.style.setProperty('--mouse-y', `${y}%`);
    }

    function handleMouseLeave(e) {
        e.currentTarget.style.setProperty('--mouse-x', '50%');
        e.currentTarget.style.setProperty('--mouse-y', '50%');
    }
}